import { TAG_CODES } from "../../tag.config"

const DEFAULT_ARROW = {
    type: 'arrow',
    tagCode: TAG_CODES.DEFAULT,
    withText: true,
    defaultText: 'Arrow',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'default',
    withFillColor: false,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    path: `M 4 55 L 280 55                       <!-- Línea recta -->
    M 280 45 L 295 55 L 280 65 Z          <!-- Punta de la flecha (rellena) -->`,
}

export default DEFAULT_ARROW